import React, { FunctionComponent, useEffect, useState } from "react"
import PositiveResponseService from "./utils/PositiveResponseService"
import PositiveResponseCrudService from "./utils/PositiveResponseCrudService"
import { AppState } from "src/store"
import { connect } from "react-redux"
import BadTicketPositiveResponsesList from "./BadTicketPositiveResponsesList/BadTicketPositiveResponsesList"
import PositiveResponseFirstLoader from "./PositiveResponseFirstLoader/PositiveResponseFirstLoader"
import ReferenceTypes from "src/store/UserReference/types"
import PositiveResponseHashService from "./utils/PositiveResponseHashService"
import PositiveResponsesHeader from "./PositiveResponsesHeader/PositiveResponsesHeader"
import PositiveResponsesNoBadTickets from "./PositiveResponsesNoBadTickets/PositiveResponsesNoBadTickets"
import "./PositiveResponses.css"

interface Props {
    loggedInUserId: number
    reference: ReferenceTypes | null
}

const PositiveResponses: FunctionComponent<Props> = (props) => {

    const { getBadTicketPositiveResponses } = PositiveResponseCrudService
    const { buildUtilityReferenceTable } = PositiveResponseHashService
    const [state, setState] = useState(PositiveResponseService.state)
    const { firstLoad, badTicketPositiveResponses } = state
    const hasBadTickets = badTicketPositiveResponses.length > 0

    useEffect(() => {
        PositiveResponseCrudService.loggedInUserId = props.loggedInUserId
        getBadTicketPositiveResponses()
        buildUtilityReferenceTable(props.reference)
        //@ts-ignore
        PositiveResponseService.webWorker.addEventListener("message", (event: { data: any }) => {
            setState(event.data)
        })
    }, [props.loggedInUserId])

    // console.log("PositiveResponses state", state)
    // console.log("PositiveResponses props", props)
    // console.log("PositiveResponses local-storage", localStorage)
    // console.log("PositiveResponses addDirty", checkIfAddIsDirty())

    return (
        <div className="PositiveResponses main-content col-sm">
            {hasBadTickets && <PositiveResponsesHeader />}
            {!firstLoad && hasBadTickets && <BadTicketPositiveResponsesList />}
            {firstLoad && <PositiveResponseFirstLoader />}
            {!hasBadTickets && !firstLoad && <PositiveResponsesNoBadTickets />}
        </div>
    )
}

const mapStateToProps = (state: AppState) => ({
    loggedInUserId: parseInt(state.user.userId),
    reference: state.userReference.userReference
})

export default connect(mapStateToProps)(PositiveResponses)